<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bDV798/tc-custom/9781429976374.jpg?1732049723554" alt="This image is the cover for the book Rendezvous Eighteenth, American Mysteries in Paris"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rendezvous Eighteenth, American Mysteries in Paris
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Rendezvous Eighteenth</i> marks the emergence of an exciting voice in  crime fiction. Ricky Jenks gave up life in the U.S. years ago and is  content, if not happy, with his life as a piano player in a small café  in the Montmartre neighborhood of Paris. He has many friends among the  other African-Americans living in Paris and is happily, if casually,  involved with a French Muslim woman. <br/><br/>But then everything  changes. His American life comes crashing down on him when his estranged  cousin wants help finding his runaway wife, whom he thinks might have  come to Paris, even though he's vague about why. That same night Ricky  finds a prostitute dead in his apartment building in Paris's Eighteenth  Arrondissment, one of the most multicultural sections of Paris.  That  these two events could be connected is something he never imagines.<br/><br/>This  intricate, absorbing thriller is ultimately much more than a suspense  novel. Lamar's detailed and vibrant portrait of life in Paris is as much  the story of a black man's alienation and redemption-indeed, the story  of an entire community searching for a home-as it is a taut thriller  about revenge, obsession, and murder</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jake Lamar
      </h2>
      
      <p class="authorDescription body article"><B>Jake Lamar</B> is the author of the acclaimed memoir <I>Bourgeois Blues</I> and three novels. Born and raised in the Bronx in New York City, he graduated from Harvard University and then spent six years writing for <I>Time</I> magazine. In 1993 he went to Paris intending to stay for a year; he now lives there full-time with his wife.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01301137